




















































































import { Vue, Component, Prop } from 'vue-property-decorator';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import moment from 'moment';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';

@Component({
  components: {
    DatePicker,
    TimePicker,
    FormFieldsContainer,
  },
})
export default class FiltrosBusqueda extends Vue {
  @Prop() formFields: FormFieldDefMap;
  @Prop() listaReq: any[];
  @Prop() estadosList: any[];
  @Prop() razonsocialList: any[];

  async handleBuscarClick() {
    this.$emit('resultadoBusqueda', true);
  }

  get fechaMaxima() {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();

    let fechaMax = yyyy + '-' + mm + '-' + dd;
    return fechaMax;
  }

  get fechaMaximaInicio() {
    return moment(this.fechaMaxima) as moment.Moment;
  }

  get fechaMinimaInicio() {
    let fechaIni = this.formFields.fechaInicio.value;
    return fechaIni as moment.Moment;
  }

  get fechaMinima() {
    let fechaMin = moment(new Date())
      .add(-12, 'months')
      .toISOString()
      .substr(0, 10);
    return fechaMin;
  }

  clearFilters() {
    this.formFields.requerimiento.value = '';
    this.formFields.estado.value = '';
    this.formFields.razonsocial.value = '';
    this.formFields.fechaInicio.value = '';
    this.formFields.fechaFin.value = '';
    this.$emit('clear');
  }
}
